// extracted by mini-css-extract-plugin
module.exports = {"button":"VYaOJ","icon":"RRIEJ","bell":"_7zWD0","heart":"F4yQG","checkBold":"hK76K","active":"lLIeu","type_subscribe":"rAyhA","type_favorite":"deYL5"};